<script lang="ts">
	import TextArea from '$lib/components/Inputs/TextArea.svelte';
	import { onDestroy } from 'svelte';

	export let prompt: string;
	export let disabled = false;

	// Not translated because Copywriter only supports English right now
	const placeholderTexts = [
		'Write a short 250 words marketing post that describes new lemonade flavors (strawberry, raspberry, blueberry) launched by Acme Coffee. Ask users to provide their feedback in the comments. Keep the tone casual yet fun. Include emojis and a link, https://www.google.com for more info.',
		'Acme Beauty is organizing an in-store VIP event on July 18, 2025 for their loyalty members. There will be prize draws, makeovers, and special one-day-only discounts on select brands. Write a short 250 word post about this event and encourages them to save the date.',
		"Write a short post of 250 words announcing Acme Cruise's new loyalty program, Acme Cruise Insiders, with details about the perks of the program including reward points tracking, and special offers on drink packages and excursions. Include the sign-up link https://example.com/acmecruiseinsiders",
	] as const;

	let placeholderIndex = 0;
	let placeholderText = placeholderTexts[placeholderIndex];

	let transitionClass = '';

	let interval = setInterval(() => {
		transitionClass = 'hide';

		setTimeout(() => {
			if (prompt === '') {
				placeholderIndex = (placeholderIndex + 1) % placeholderTexts.length;
				placeholderText = placeholderTexts[placeholderIndex];
			}
			transitionClass = 'show';
		}, 300);
	}, 4000);

	onDestroy(() => {
		clearInterval(interval);
	});
</script>

<div class="copywriter-prompt-textarea">
	{#if !prompt}
		<div class="placeholder-overlay {transitionClass}">
			{placeholderText}
		</div>
	{/if}
	<TextArea bind:value={prompt} fullWidth name="prompt" {disabled} rows={6} />
</div>

<style>
	.copywriter-prompt-textarea {
		position: relative;
		inline-size: 100%;
	}

	/* stylelint-disable property-no-vendor-prefix */
	.placeholder-overlay {
		position: absolute;
		inset-block-start: calc(var(--gutterSmall) + 1px);
		inset-inline: calc(var(--gutterSmall) + 1px);
		transition: opacity 0.3s ease-in-out;
		opacity: 1;
		color: #999;
		font-family: inherit;
		font-size: inherit;
		line-height: inherit;
		word-wrap: break-word;
		white-space: pre-wrap;
		pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.placeholder-overlay.hide {
		opacity: 0;
	}

	.placeholder-overlay.show {
		opacity: 1;
	}
</style>
